import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import { Counter } from '../../Counter'
import { FloatingTooltip } from '../../Floating'
import { ICON_COLOR, IconWithTooltip } from '../../Icon'

import * as styles from './SubMenuAccountListItem.module.css'

import ReconnectIcon from '../../../icons/connection-failed.svg'

function SubMenuAccountListItem({
  children,
  className = styles.SubMenuAccountListItem,
  count,
  isActive,
  item,
  reconnect,
  selected,
  onClick,
  onReconnect,
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const textClassName = classNames(
    styles.text,
    {
      [styles.disabled]: !isActive,
    },
    {
      [styles.selected]: selected,
    }
  )

  const canReconnect = item?.permissions?.can_reconnect

  function handleReconnect(e) {
    stopPropagation(e)

    if (canReconnect) {
      onReconnect?.(item)
    }
  }

  const reconnectClassName = classNames(styles.reconnect, {
    [styles.canNotReconnect]: !canReconnect,
  })

  function handleClick() {
    onClick(item)
  }

  return (
    <div className={className} onClick={handleClick}>
      <FloatingTooltip content={children} disabled={!overflow}>
        <span className={textClassName} ref={setContentOverflowRef}>
          {children}
        </span>
      </FloatingTooltip>
      {reconnect ? (
        <IconWithTooltip
          Icon={ReconnectIcon}
          className={reconnectClassName}
          color={ICON_COLOR.Red}
          tooltip={t('Email.FailConnection')}
          onClick={handleReconnect}
        />
      ) : null}
      {count > 0 && (
        <div className={styles.counter}>
          <Counter count={count} />
        </div>
      )}
    </div>
  )
}

export default SubMenuAccountListItem
